import { isEmail } from 'Utils/Validators/email'

export function validate(values) {
  const errors = {}

  if (!values.email) {
    errors.email = 'Required'
  } else if (!isEmail(values.email)) {
    errors.email = 'This email is incorrect'
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/Containers/Form/ForgotPassword/validate.js